/*
  V4 cart drawer behaviour (sections/ru4-cart-drawer.liquid).

  - Any add-to-cart form on the site is sent with /cart/add.js and opens the
    drawer instead of redirecting to /cart. Forms with data-ru4-native are left alone.
  - The header cart icon opens the drawer (except on the /cart page itself).
  - After every change the drawer is re-rendered server-side through the
    Section Rendering API, so totals, the base check and pay-in-4 are always
    the real cart's numbers.
  - Tracking goes through RU4.track (snippets/ru4-track.liquid).
*/
(function () {
  'use strict';

  var RU4 = (window.RU4 = window.RU4 || {});
  if (!RU4.track) RU4.track = function () {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'ru4-cart-drawer';

  var el, panel, lastTrigger = null, busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function money(cents) {
    return Math.round(cents) / 100;
  }

  function init() {
    el = $('[data-ru4-cart]');
    if (!el) return;
    panel = $('.ru4-cart__panel', el);
    if (el.parentNode !== document.body) document.body.appendChild(el.closest('.shopify-section') || el);
    bind();
  }

  /* ---------- open / close ---------- */
  function open(source) {
    if (!el) return;
    lastTrigger = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ru4-cart-open');
    setTimeout(function () { panel && panel.focus({ preventScroll: true }); }, 50);
    var dyn = $('[data-ru4-cart-dynamic]', el);
    RU4.track('cart_drawer_open', {
      source: source || 'unknown',
      item_count: dyn ? Number(dyn.getAttribute('data-count')) : null,
      value: dyn ? money(Number(dyn.getAttribute('data-total'))) : null
    });
  }

  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ru4-cart-open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }

  /* ---------- render ---------- */
  function refresh() {
    return fetch(root + 'cart?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-ru4-cart-dynamic]', doc);
        var current = $('[data-ru4-cart-dynamic]', el);
        if (fresh && current) current.parentNode.replaceChild(fresh, current);
        var count = fresh ? Number(fresh.getAttribute('data-count')) : 0;
        var actions = $('[data-ru4-cart-actions]', el);
        if (actions) actions.classList.toggle('is-hidden', count === 0);
        updateBubble(count);
        document.dispatchEvent(new CustomEvent('ru4:cart:updated', { detail: { count: count } }));
      });
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function setBusy(on) {
    busy = on;
    if (el) el.classList.toggle('is-busy', on);
  }

  /* ---------- cart API ---------- */
  /*
    items: [{ id, quantity, properties }]
    meta:  { source, product_id, price, colourway, title, skipOpen, track:false }
  */
  function add(items, meta) {
    meta = meta || {};
    setBusy(true);
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body && (body.description || body.message) || 'Could not add to cart');
          return body;
        });
      })
      .then(function (body) {
        if (meta.track !== false) {
          (body.items || []).forEach(function (line) {
            RU4.track('add_to_cart', {
              source: meta.source || 'form',
              product_id: line.product_id,
              variant_id: line.variant_id,
              price: money(line.final_price != null ? line.final_price : line.price),
              quantity: line.quantity,
              colourway: RU4.colourway ? RU4.colourway(line.product_title) : '',
              product_title: line.product_title
            });
          });
        }
        return refresh().then(function () {
          setBusy(false);
          if (!meta.skipOpen) open(meta.source || 'add_to_cart');
          return body;
        });
      })
      .catch(function (err) {
        setBusy(false);
        throw err;
      });
  }

  function change(key, quantity) {
    setBusy(true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refresh(); })
      .then(function () { setBusy(false); }, function () { setBusy(false); });
  }

  /* ---------- email me this cart ---------- */
  function saveCart(form) {
    var msg = $('[data-ru4-save-msg]', form);
    var email = form.email.value.trim();
    var consent = form.consent.checked;
    msg.classList.remove('is-error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.classList.add('is-error');
      return;
    }
    if (!consent) {
      msg.textContent = 'Tick the box so we can email your cart to you.';
      msg.classList.add('is-error');
      return;
    }
    msg.textContent = 'Saving…';

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var permalink = location.origin + root + 'cart/' + cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        var data = new URLSearchParams();
        data.append('form_type', 'customer');
        data.append('utf8', '✓');
        data.append('contact[email]', email);
        data.append('contact[tags]', 'cart-saved,prospect,newsletter');
        data.append('contact[accepts_marketing]', 'true');
        data.append('contact[note]', 'Saved cart: ' + permalink);
        return fetch(root + 'contact', { method: 'POST', credentials: 'same-origin', body: data }).then(function (r) {
          if (r.url && r.url.indexOf('challenge') > -1) {
            /* Shopify wants a bot check: hand over to a normal form post */
            nativeSubmit(email);
            return;
          }
          RU4.track('email_cart_saved', {
            item_count: cart.item_count,
            value: money(cart.total_price),
            cart_permalink: permalink
          });
          msg.textContent = 'Saved — we’ll email your cart to you shortly.';
          form.querySelector('button[type=submit]').disabled = true;
        });
      })
      .catch(function () {
        msg.textContent = 'Sorry, that didn’t work. Please try again.';
        msg.classList.add('is-error');
      });
  }

  function nativeSubmit(email) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = root + 'contact';
    [['form_type', 'customer'], ['utf8', '✓'], ['contact[email]', email], ['contact[tags]', 'cart-saved,prospect,newsletter'], ['contact[accepts_marketing]', 'true']].forEach(function (p) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = p[0]; i.value = p[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  /* ---------- events ---------- */
  function bind() {
    /* Any add-to-cart form on the site -> AJAX + drawer */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (form.matches('[data-ru4-save-form]')) {
        e.preventDefault();
        saveCart(form);
        return;
      }
      if (!form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-ru4-native')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var fd = new FormData(form);
      var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') props[m[1]] = v;
      });
      if (Object.keys(props).length) item.properties = props;
      var btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = true;
      add([item], { source: form.getAttribute('data-ru4-source') || 'form' })
        .catch(function (err) { window.alert(err.message); })
        .then(function () { if (btn) btn.disabled = false; });
    }, true);

    /* Header cart icon -> drawer */
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"], .js-drawer-open-cart, [data-ru4-cart-open]');
      if (!link || el.contains(link)) return;
      if (location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open('header');
    }, true);

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ru4-cart-close]')) { close(); return; }

      var q = t.closest('[data-ru4-qty]');
      if (q && !busy) { change(q.getAttribute('data-key'), Number(q.getAttribute('data-ru4-qty'))); return; }

      var base = t.closest('[data-ru4-add-base]');
      if (base && !busy) {
        var id = Number(base.getAttribute('data-ru4-add-base'));
        RU4.track('cart_base_upsell_click', { variant_id: id });
        base.disabled = true;
        add([{ id: id, quantity: 1 }], { source: 'cart_base_upsell', skipOpen: true })
          .catch(function (err) { window.alert(err.message); base.disabled = false; });
        return;
      }

      var tog = t.closest('[data-ru4-save-toggle]');
      if (tog) {
        var f = $('[data-ru4-save-form]', el);
        var show = f.hasAttribute('hidden');
        if (show) f.removeAttribute('hidden'); else f.setAttribute('hidden', '');
        tog.setAttribute('aria-expanded', String(show));
        if (show) f.email.focus();
        return;
      }

      if (t.closest('[data-ru4-checkout]')) {
        var dyn = $('[data-ru4-cart-dynamic]', el);
        RU4.track('begin_checkout', {
          source: 'cart_drawer',
          item_count: dyn ? Number(dyn.getAttribute('data-count')) : null,
          value: dyn ? money(Number(dyn.getAttribute('data-total'))) : null
        });
        return;
      }

      var chat = t.closest('[data-ru4-chat]');
      if (chat) {
        RU4.track('chat_open', { location: 'cart', method: 'chat' });
        var target = document.querySelector(chat.getAttribute('data-ru4-chat'));
        if (target) target.click();
        return;
      }
      if (t.closest('[data-ru4-call]')) RU4.track('chat_open', { location: 'cart', method: 'phone' });
    });

    /* Express checkout buttons (Shop Pay, PayPal, Apple/Google Pay) count as begin_checkout too */
    var express = $('.ru4-cart__express', el);
    if (express) {
      express.addEventListener('click', function () {
        RU4.track('begin_checkout', { source: 'cart_drawer_express' });
      }, true);
    }

    document.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(focusable, function (n) { return n.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Back/forward cache can show a stale cart */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  RU4.cart = { open: open, close: close, add: add, change: change, refresh: refresh };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* V4 lifestyle photos on product cards (snippets/ru4-lifestyle.liquid).
   Loaded when the card is near the screen. Desktop shows them on hover (CSS);
   phones have no hover, so a card that stays in view for a moment fades to
   its lifestyle photo, and back to the studio shot when it leaves. */
(function () {
  var imgs = document.querySelectorAll('img[data-ru4-life-src]');
  if (!imgs.length) return;
  function load(img) {
    if (!img.hasAttribute('data-ru4-life-src')) return;
    img.srcset = img.getAttribute('data-ru4-life-srcset');
    img.src = img.getAttribute('data-ru4-life-src');
    img.removeAttribute('data-ru4-life-src');
  }
  if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }
  var near = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
  }, { rootMargin: '300px 300px' });
  imgs.forEach(function (i) { near.observe(i); });

  if (window.matchMedia('(hover: hover)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var timers = new WeakMap();
  var seen = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var card = e.target;
      clearTimeout(timers.get(card));
      if (e.intersectionRatio >= 0.85) {
        timers.set(card, setTimeout(function () { card.classList.add('is-life'); }, 900));
      } else {
        card.classList.remove('is-life');
      }
    });
  }, { threshold: [0, 0.85] });
  imgs.forEach(function (i) { var c = i.parentElement; if (c) seen.observe(c); });
})();
